// This needs to match the API's ZipCodeAnalysisSortableColumnEnum
// the numbers are just for easy debugging
export enum ZipCodeSortableColumnEnum {
  Unknown = 0,
  StateName = 1,
  County = 2,
  City = 3,
  ZipClass = 4,
  ZipCode = 5,
  SpecialtyGroupCode = 6,
  MinProviderCount = 7,
  ReqDist = 8,
  ReqTime = 9,
  MinPassPercent = 10,
  MetPassPercent = 11,
  MembershipCount = 12,
  ProviderCount = 13,
  MemberCountWithAccess = 14,
  WithAccessPercent = 15,
  MemberCountWithoutAccess = 16,
  WithoutAccessPercent = 17,
  AverageDistance = 18,
  MaximumDistance = 19,
  AverageTime = 20,
  MaximumTime = 21,
  AverageDistance2 = 22,
  AverageDistanceWithAccess = 23,
  AverageDistanceWithAccess2 = 24,
  AverageDistanceWithoutAccess = 25,
  AverageDistanceWithoutAccess2 = 26,
  AverageTime2 = 27,
  AverageTimeWithAccess = 28,
  AverageTimeWithAccess2 = 29,
  AverageTimeWithoutAccess = 30,
  AverageTimeWithoutAccess2 = 31,
  MaximumDistance2 = 32,
  MaximumDistanceWithAccess = 33,
  MaximumDistanceWithAccess2 = 34,
  MaximumDistanceWithoutAccess = 35,
  MaximumDistanceWithoutAccess2 = 36,
  MaximumTime2 = 37,
  MaximumTimeWithAccess = 38,
  MaximumTimeWithAccess2 = 39,
  MaximumTimeWithoutAccess = 40,
  MaximumTimeWithoutAccess2 = 41,
  MetTime = 42,
  MetDist = 43,
  WithAccessByDistancePercent = 44,
  WithAccessByTimePercent = 45,
  MarketAccessPercent = 46,
  MarketServicing = 47,
  MarketPercent = 48,
  MembershipType = 49,
  InZipProviderCount = 50,
  InZipMarketProviderCount = 51,
  SpecialtyGroupExceptionStatus = 52,
  ServicingProviderToMemberRatio = 53,
  GapFillStatus = 54,
  GapFillStatusUpdatedByName = 55,
  GapFillStatusUpdatedDate = 56,
  GapAgeDays = 57,
}

/* This needs to match the API's ZipClassAggregateSortableColumnEnum */
export enum ZipClassSortableColumnEnum {
  Unknown = 0,
  ZipClass = 1,
  SpecialtyGroupCode = 2,
  MinProviderCount = 3,
  ReqDist = 4,
  ReqTime = 5,
  MinPassPercent = 6,
  MembershipCount = 7,
  ProviderCount = 8,
  MemberCountWithAccess = 9,
  WithAccessPercent = 10,
  MemberCountWithoutAccess = 11,
  WithoutAccessPercent = 12,
  MetOverall = 13,
  AverageDistance = 14,
  AverageDistanceWithAccess = 15,
  AverageDistanceWithoutAccess = 16,
  MaximumDistance = 17,
  MaximumDistanceWithAccess = 18,
  MaximumDistanceWithoutAccess = 19,
  AverageTime = 20,
  AverageTimeWithAccess = 21,
  AverageTimeWithoutAccess = 22,
  MaximumTime = 23,
  MaximumTimeWithAccess = 24,
  MaximumTimeWithoutAccess = 25,
  AverageDistance2 = 26,
  AverageDistanceWithAccess2 = 27,
  AverageDistanceWithoutAccess2 = 28,
  MaximumDistance2 = 29,
  MaximumDistanceWithAccess2 = 30,
  MaximumDistanceWithoutAccess2 = 31,
  AverageTime2 = 32,
  AverageTimeWithAccess2 = 33,
  AverageTimeWithoutAccess2 = 34,
  MaximumTime2 = 35,
  MaximumTimeWithAccess2 = 36,
  MaximumTimeWithoutAccess2 = 37,
  WithAccessByDistancePercent = 38,
  WithAccessByTimePercent = 39,
  MarketAccessPercent = 40,
  MarketServicing = 41,
  MarketPercent = 42,
  MembershipType = 43,
  SpecialtyGroupExceptionsCount = 44,
  InClassProviderCount = 45,
  InClassMarketProviderCount = 46,
  ServicingProviderToMemberRatio = 47,
}
